/* @flow weak */
import ReactDOM from 'react-dom';

import DOM from 'lib/DOM';
import KeyState from 'lib/KeyState';
import focusNode from 'utils/focusNode';
import getActiveElement from 'utils/getActiveElement';

const LayerAutoFocus = {
  _activeElement: null,

  componentWillMount() {
    this._activeElement = getActiveElement();
  },

  componentDidMount() {
    // TODO: getTabbableElements() and focus the first tabbable element, so that things like
    // forms or buttons are automatically focused when opening dialogs

    // It's possible for the active element to change because of a `focusNode` call within the
    // rendered subtree. Check to see if the activeElement is within the modal.
    const node = ReactDOM.findDOMNode(this);
    const activeElement = getActiveElement();
    if (!node.contains(activeElement)) {
      if (DOM.getOffset(node).top < 0) {
        return;
      }

      focusNode(node);
    }
  },

  componentWillUnmount() {
    if (KeyState.isKeyDown()) {
      focusNode(this._activeElement);
    }
  },
};

export default LayerAutoFocus;



// WEBPACK FOOTER //
// ./src/components/mixins/LayerAutoFocus.js